import { render } from "./ReturnedPaymentsReportPage.vue?vue&type=template&id=48d58b6c&scoped=true"
import script from "./ReturnedPaymentsReportPage.vue?vue&type=script&lang=js"
export * from "./ReturnedPaymentsReportPage.vue?vue&type=script&lang=js"

import "./ReturnedPaymentsReportPage.vue?vue&type=style&index=0&id=48d58b6c&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/fep.theismailiusa.org/srv/ibsreg-test.theismailiusa.org/github-httpdocs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d58b6c"]])

export default __exports__